import * as React from 'react';
import { Text } from '../../new-libby';
export var renderFlatCatName = function (cat) {
    return { label: "" + (cat.parentName ? cat.parentName + ' › ' : '') + cat.name, value: cat.id, className: "id-" + cat.id };
};
export var categoryOptionRenderer = function (option) {
    return (React.createElement("div", { className: option.className },
        React.createElement(Text, { ellipsis: true, relativeToBody: true }, option.label)));
};
//# sourceMappingURL=common.js.map